import { datadogRum } from '@datadog/browser-rum';

export default function setupElementStyles(
  element: HTMLElement,
  maxHeight: number,
  minHeight = 160,
): Record<string, string | number> | null {
  try {
    const elementRect = element.getBoundingClientRect();
    const availableSpace = document.documentElement.scrollHeight - elementRect.bottom;

    // element position is lower than the dropdown height
    // or the space is lower than zero
    if (elementRect.top < maxHeight || availableSpace <= 0) {
      return null;
    }

    // not enough space at the bottom
    // means display the dropdown above the element (should be extremely rare)
    if (availableSpace < minHeight) {
      return {
        bottom: `${elementRect.height}px`,
      };
    }

    // set max-height by available space at the bottom
    if (availableSpace <= maxHeight) {
      return {
        'max-height': `${availableSpace.toFixed(0)}px`,
      };
    }

    return null;
  } catch (error) {
    datadogRum.addError(error);

    // CSS rules only
    return null;
  }
}
